import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../api';
import './Landing.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [step, setStep] = useState('request');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [fpError, setFpError] = useState('');
  const [fpSuccess, setFpSuccess] = useState('');
  const [fpLoading, setFpLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await auth.login({ email, password });
      localStorage.setItem('token', res.data.access_token);
      navigate('/dashboard');
    } catch (err) {
      setError('Неверный email или пароль');
    } finally { setLoading(false); }
  };

  const handleRequest = async (e) => {
    e.preventDefault();
    setFpError(''); setFpSuccess(''); setFpLoading(true);
    try {
      await auth.forgotPassword(email);
      setFpSuccess('Если аккаунт с таким email есть, мы отправили код восстановления на почту.');
      setStep('reset');
    } catch (err) {
      setFpError(err.response?.data?.detail || 'Не удалось отправить код восстановления');
    } finally { setFpLoading(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setFpError(''); setFpSuccess('');
    if (newPassword !== confirmPassword) { setFpError('Пароли не совпадают'); return; }
    if (newPassword.length < 6) { setFpError('Пароль должен быть не короче 6 символов'); return; }
    setFpLoading(true);
    try {
      await auth.resetPassword(email, resetCode, newPassword);
      setFpSuccess('Пароль обновлён. Теперь можно войти.');
      setTimeout(() => {
        setShowForgot(false); setStep('request');
        setResetCode(''); setNewPassword(''); setConfirmPassword(''); setFpSuccess('');
      }, 1800);
    } catch (err) {
      setFpError(err.response?.data?.detail || 'Не удалось восстановить пароль. Проверьте код и попробуйте снова.');
    } finally { setFpLoading(false); }
  };

  const closeForgot = () => { setShowForgot(false); setStep('request'); setFpError(''); setFpSuccess(''); };

  return (
    <div className="sg">
      <div className="auth">
        <div className="auth-card">
          <Link className="brand" to="/"><img src="/project_logo.png" alt="SkillGate" />SkillGate</Link>
          <h1>С возвращением</h1>
          <p className="asub">Войдите, чтобы продолжить работу с тестами</p>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="field">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.ru" autoComplete="email" required />
            </div>
            <div className="field">
              <div className="field-row">
                <label htmlFor="pass">Пароль</label>
                <button type="button" className="auth-textbtn" onClick={() => setShowForgot(!showForgot)}>Забыли пароль?</button>
              </div>
              <input id="pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" autoComplete="current-password" required />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Входим…' : 'Войти'}</button>
          </form>

          <p className="auth-foot">Нет аккаунта? <Link to="/register">Зарегистрироваться</Link></p>

          {showForgot && (
            <div className="auth-divider">
              <h2 style={{ fontSize: 18, marginTop: 0, textAlign: 'left' }}>Восстановление пароля</h2>
              <p className="asub" style={{ textAlign: 'left', marginTop: 6, marginBottom: 18 }}>
                {step === 'request' ? 'Укажите email — пришлём код для сброса.' : 'Введите код из письма и новый пароль.'}
              </p>
              {fpError && <div className="auth-error">{fpError}</div>}
              {fpSuccess && <div className="auth-success">{fpSuccess}</div>}

              {step === 'request' ? (
                <form onSubmit={handleRequest}>
                  <div className="field">
                    <label>Email</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email вашего аккаунта" required />
                  </div>
                  <button type="submit" className="btn btn-primary" disabled={fpLoading}>{fpLoading ? 'Отправляем…' : 'Отправить код'}</button>
                  <p style={{ textAlign: 'center', marginTop: 12 }}><button type="button" className="auth-textbtn" style={{ color: 'var(--ink-500)' }} onClick={closeForgot}>Отмена</button></p>
                </form>
              ) : (
                <form onSubmit={handleReset}>
                  <div className="field"><label>Email</label><input type="email" value={email} disabled /></div>
                  <div className="field"><label>Код из письма</label><input type="text" value={resetCode} onChange={(e) => setResetCode(e.target.value)} placeholder="Например, 482913" maxLength={10} required /></div>
                  <div className="field"><label>Новый пароль</label><input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Минимум 6 символов" minLength={6} required /></div>
                  <div className="field"><label>Повторите пароль</label><input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Ещё раз новый пароль" minLength={6} required /></div>
                  <button type="submit" className="btn btn-primary" disabled={fpLoading}>{fpLoading ? 'Сохраняем…' : 'Установить новый пароль'}</button>
                  <p style={{ textAlign: 'center', marginTop: 12, display: 'flex', gap: 18, justifyContent: 'center' }}>
                    <button type="button" className="auth-textbtn" style={{ color: 'var(--ink-500)' }} onClick={() => { setStep('request'); setResetCode(''); setNewPassword(''); setConfirmPassword(''); setFpError(''); }}>Назад</button>
                    <button type="button" className="auth-textbtn" style={{ color: 'var(--ink-500)' }} onClick={closeForgot}>Отмена</button>
                  </p>
                </form>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
